// extracted by css-extract-rspack-plugin
export default {"accordion":"sWgwQ","item":"tDu4G","control":"ZVGaA","label":"bs_J1","chevron":"dW0Q1","content":"Pvv4Z","contentRow":"H6f7A","cell":"X0Cpj"};